import sortBy from "lodash/sortBy"
import { defineStore } from "pinia"

import http from "~/services/http"
import type EklaseJournalWithStudents from "~/types/schema/eklase/JournalWithStudents"

interface ISendEklaseParams extends IErrorAndSuccessCallbacks {
  body: {
    objectId: number // Id of the smart_file/product/worksheet_file
    objectType: "product" | "smart_file" | "worksheet_file"
    journalId: string // Eklase identifier
    studentIds: string[] // student eklase uid array
    dateInDiary: string // format (YYYY-MM-DD)
    hometaskWorkType: "hometask" | "classwork"
    comment?: string // Teacher comment/message to e-klase diary
    urlToHometask: string // Url to smart-file, etc
    smartFileStartLesson?: boolean // Whether to start the lesson
    objectSubjectId?: number
    objectGradeId?: number
    worksheetFileAllowance?: boolean
  }
}

interface IFetchJournals extends IErrorAndSuccessCallbacks {
  smartFileId?: number
}

export const useEklaseStore = defineStore("eklaseStore", {
  state: () => ({
    modalOpen: false,
    journals: [] as EklaseJournalWithStudents[],
  }),

  actions: {
    fetchJournals({ smartFileId, successCallback, errorCallback }: IFetchJournals) {
      let url = "v1/eklase/teacher/journals-all-students"
      if (smartFileId) {
        url += `?smart_file_id=${smartFileId}`
      }

      http.get({
        url,
        successCallback: (ctx) => {
          this.journals = sortBy(ctx.response._data.journals, ["grade", "group"])
          successCallback && successCallback(ctx)
        },
        errorCallback: (ctx) => {
          errorCallback && errorCallback(ctx)
        },
      })
    },

    setModalOpen(isOpen: boolean) {
      this.modalOpen = isOpen
    },

    sendToEklase({ body, successCallback = null, errorCallback = null }: ISendEklaseParams) {
      http.post({
        url: "/v1/eklase/teacher/send_eklase",
        body,
        successCallback: (ctx) => {
          successCallback && successCallback(ctx)
        },
        errorCallback: (ctx) => {
          errorCallback && errorCallback(ctx)
        },
      })
    },
  },
})
